<template>
  <div>
    <div class="trading_top">
      <div class="bold_title">原装二手</div>
      <div class="bold_title">零配件交易平台</div>
      <div>让信息流先于物流，从而提升交易效率，为社会节资源</div>
    </div>
    <div class="trading_bottom">
      <div class="bottom_content">
        <div class="trading_left">
          <div class="trading_left_content">
            <div class="supply">供应</div>
            <div class="line" style="margin: 5px 0;"></div>
            <div class="explain_div">专业原装二手配件贸易商</div>
            <div class="arrow">
              <div class="line"></div>
              <div class="cross_part">
                <div class="line_long"></div>
                <div class="lineCircle"></div>
              </div>
            </div>
            <div class="explain_div" style="margin-top: 20px;display: flex;flex-direction: column;">
              <span>1800余家有资质拆解厂</span>
              <span style="font-size: 12px;">(商务部公示数据)</span>
            </div>
            <div class="arrow">
              <div class="line"></div>
              <div class="cross_part">
                <div class="line_long"></div>
                <div class="lineCircle"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="trading_middle">
          <div>
            <div class="serve">运输服务</div>
            <div class="serve_line">
              <div class="line"></div>
              <div class="lineCircle"></div>
              <!-- <span style="color: #fff;">●</span> -->
            </div>
          </div>
          <div class="phone_part">
            <div class="phone_title">原装二手</div>
            <div>零配件</div>
            <div>交易平台</div>
          </div>
        </div>
        <div class="trading_right">
          <div class="trading_right_content">  
            <div class="supply">需求</div>
            <div class="line" style="margin: 5px 0;"></div>
            <div class="explain_div" style="display: flex;flex-direction: column;">
              <span>91万余家全国汽车维修厂</span>
              <span style="font-size: 12px;">(水滴信用查询数据)</span>
            </div>
            <div class="arrow_right">
              <div class="cross_part">
                <div class="lineCircle"></div>
                <div class="line_long"></div>
              </div>
              <div class="line"></div>
            </div>
            <div class="explain_div" style="margin-top: 20px;">C端零配件需求者</div>
            <div class="arrow_right">
              <div class="cross_part">
                <div class="lineCircle"></div>
                <div class="line_long"></div>
              </div>
              <div class="line"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ind_enter">
      <div class="ind_enter_content">
        <div class="ind_enter_title">商家入驻</div>
        <div class="ind_enter_bottom">
          <div class="ind_enter_bottom_item" style="margin-right: 30px;" @click="showDialog">全国维修店</div>
          <div class="ind_enter_bottom_item" @click="showDialog">二手件销售商</div>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="visible"
      :before-close="closeFunc"
      width="650px"
    >
      <div>
        <span class="dialog_title">请填写你的信息，招商经理将主动与你联系</span>
        <el-divider></el-divider>
      </div>
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="联系人" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入联系电话" clearable></el-input>
        </el-form-item>
        <el-form-item label="申请人邮箱" prop="mail">
          <el-input v-model="form.mail" placeholder="请输入申请人邮箱" clearable></el-input>
        </el-form-item>
        <el-form-item label="所在城市" prop="province" class="city_select">
          <el-select v-model="form.province" placeholder="请选择省" @change="provinceChange" clearable>
            <el-option
              v-for="item in provinceList"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
          <el-select v-model="form.city" placeholder="请选择市" clearable>
            <el-option
              v-for="item in cityList"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
          <el-input v-model="form.address" placeholder="请输入详细地址" clearable></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="remark">
          <el-input v-model="form.remark" :autosize="{ minRows: 4}" placeholder="请描述您所从事的行业，拥有哪些能力或资源等等" clearable type="textarea"></el-input>
        </el-form-item>
        <div class="submit_button" @click="submitForm">提交</div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Trading',
  data() {
    const valCheck = (rule, value, callback) => {
      if(value === "" || value === null) {
        callback(new Error('请选择省份'))
      } else if(this.form.city === '' || this.form.city === null) {
        callback(new Error('请选择市'))
      } else {
        callback()
      }
    }
    return {
      visible: false,
      form: {
        name: '',
        phone: '',
        mail: '',
        province: '',
        city: '',
        address: '',
        remark: '',
      },
      provinceList: [],
      cityList: [],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        remark: [{ required: true, message: "请输入内容", trigger: "blur" }],
        province: [{ required: true, validator: valCheck, trigger: "change" }],
      }
    }
  },
  mounted() {
    this.queryProvince()
  },
  methods: {
    showDialog() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    closeFunc() {
      this.resetFunc()
    },
    queryProvince() {
      this.$axios({
        method: 'get',
        url: 'https://chaichegj.cn:9015/sys/area/getProvinceSelects',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      }).then(res => {
        this.provinceList = res.data.result
      })
    },
    provinceChange(e) {
      this.form.city = ''
      if(e) {
        this.$axios({
          method: 'get',
          url: 'https://chaichegj.cn:9015/sys/area/getCitySelects',
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
          params: {
            id: e
          }
        }).then(res => {
          this.cityList = res.data.result
        })
      }
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.$axios({
            method: 'post',
            url: 'https://chaichegj.cn:9015/sys/indexForm/addJoinForm',
            headers: {
              'Content-Type': 'application/json;charset=utf-8',
            },
            data: JSON.stringify({
              ...this.form,
              type: '1'
            })
          }).then(res => {
            if(res.data.appCode === "S0000") {
              this.$message({ message: '提交成功！', type: 'success' })
              this.resetFunc()
            }
          })
        }
      })
    },
    resetFunc() {
      this.form = {
        name: '',
        phone: '',
        mail: '',
        province: '',
        city: '',
        address: '',
        remark: ''
      }
      this.$refs.form.clearValidate()
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.trading_top {
  height: calc(100vh - 400px);
  background-color: #c8cfd9;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
}
.bold_title {
  color: #f8753f;
  font-size: 50px;
  font-weight: bold;
  margin-bottom: 5px;
}
.trading_bottom {
  height: calc(100vh - 70px);
  background-color: #f8753f;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .bottom_content {
    display: flex;
    height: 95%;
    width: 80%;
    justify-content: space-around;
    .trading_left {
      width: 30%;
      display: flex;
      flex-direction: column;
      align-items: end;
      justify-content: center;
      .trading_left_content {
        height: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    }
    .trading_middle {
      width: 30%;
      .serve {
        text-align: center;
        font-size: 24px;
        color: #fff;
      }
      .serve_line {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .lineCircle {
        width: 8px;
        height: 8px;
        background-color: #fff;
        border-radius: 25px;
      }
      .phone_part {
        height: 80%;
        background-image: url('../../assets/image/7.png');
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 36px;
        color: #fff;
        letter-spacing: 5px;
        .phone_title {
          font-weight: bold;
        }
      }
    }
    .trading_right {
      width: 30%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      .trading_right_content {
        height: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
.explain_div {
  width: 240px;
  box-sizing: border-box;
  text-align: center;
  padding: 10px;
  background-color: #ff966c;
  color: #fff;
  border-radius: 20px;
  font-size: 18px;
  letter-spacing: 1px;
}
.line {
  height: 25px;
  border-left: 1px dashed #fff;
}
.supply {
  font-size: 24px;
  color: #fff;
}
.arrow {
  display: flex;
  align-items: baseline;
  padding-left: 120px;
  margin-top: 5px;
  .cross_part {
    display: flex;
    align-items: center;
  }
}
.arrow_right {
  display: flex;
  align-items: baseline;
  margin-top: 5px;
  padding-right: 112px;
  .cross_part {
    display: flex;
    align-items: center;
    position: relative;
    .lineCircle {
      position: absolute;
    }
  }
}
.line_long {
  width: 112px;
  border-bottom: 1px dashed #fff;
}
.lineCircle {
  width: 8px;
  height: 8px;
  background-color: #fff;
  border-radius: 25px;
}
.ind_enter {
  height: calc(100vh - 250px);
  background-color: #346ccb;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ind_enter_content {
  width: 70%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.ind_enter_title {
  font-size: 36px;
  color: #fff;
  margin-bottom: 40px;
  letter-spacing: 5px;
}
.ind_enter_bottom {
  display: flex;
  color: #3e6aae;
}
.ind_enter_bottom_item {
  background: linear-gradient(#dfebfb, #b1ceee);
  border-radius: 25px;
  font-size: 24px;
  padding: 10px 40px;
  cursor: pointer;
}

::v-deep .el-dialog__body {
  display: flex;
  flex-direction: column;
  // padding: 30px 50px;
}
::v-deep .el-dialog__header {
  padding: 0;
}
.dialog_title {
  font-size: 18px;
  color: #02b2b5;
}
::v-deep .el-divider--horizontal {
  margin: 10px 0;
}
.submit_button {
  width: 100px;
  text-align: center;
  padding: 10px 50px;
  margin-left: 120px;
  background-color: #02b2b5;
  color: #fff;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
::v-deep .el-input--suffix {
  width: 450px;
}
.city_select {
  ::v-deep .el-form-item__content {
    display: flex;
  }
  ::v-deep .el-input--suffix{
    width: 150px;
  }
}
@media screen and (max-width: 1366px) {
  .trading_top {
    height: calc(100vh - 200px);
  }
  .trading_bottom {
    height: 105vh;
  }
}
</style>